import Cookie from 'js-cookie';

const authenticator = {
    isLoggedIn: () => Cookie.get('token'),
    logout: () => Cookie.remove('token'),
};
export default authenticator;
